import React from "react";
import { isMobile } from "react-device-detect";
import "./styles.scss";
const background = require("../../assets/img/background.jpg");

const composeSVG = (width, height) => {
  let svg = "";
  svg += `M${width},0`; // Initial point
  svg += `C${(4 * width) / 5},${(height * 3) / 4},${width / 2},${height *
    0.95},`; // top curve
  svg += `0,${height * 0.95}`; // second point
  svg += `L 0 ${2 * height}`; // Bottom point
  svg += `C${width / 5},${(height * 6) / 5},${width / 2},${height * 1.05},`; // top curve
  svg += `${width} ${height * 1.05}`; // Bottom point
  svg += `Z`; // close path
  return svg;
};

export default class Component extends React.Component {
  state = { width: 0, height: 0 };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { innerWidth, innerHeight } = window;
    if (isMobile && this.state.width !== innerWidth) {
      this.setState({ width: innerWidth, height: innerHeight });
    } else if (!isMobile) {
      this.setState({ width: innerWidth, height: innerHeight });
    }
  };
  render() {
    const { width, height } = this.state;
    return (
      <svg className="background">
        <defs>
          <pattern
            id="image"
            patternUnits="userSpaceOnUse"
            width="100%"
            height="100%"
          >
            <image
              href={background}
              x="0"
              y="0"
              width="100%"
              height="100%"
              preserveAspectRatio="xMidYMid slice"
            />
          </pattern>
        </defs>
        <path d={composeSVG(width, height)} id="path-1" fill={"url(#image)"} />
      </svg>
    );
  }
}
